export class CoachingDashboardActiveTabChange {
  static readonly type = '[CoachingDashboard] ActiveTabChange';

  constructor(public activeTab: number) {}
}
